// IMPORTS
import _ from 'lodash'
import swal from 'sweetalert'
import axios from 'axios'
import mobiscroll from '@mobiscroll/javascript'

// DEFINITIONS
const recargaSaldo = 'recargas/process'

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    BlackfonRecarga: async ({ }, payload) => {
        try {
            let data2send = payload,
                response = await axios.post(recargaSaldo, data2send, { withCredentials: false });

            if (response.data.type == 'redirect') {
                // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
                if (response.msg) {
                    let swalResponse = await swal({
                        icon: response.class,
                        title: response.msg,
                        buttons: {
                            cancel: 'Cancelar',
                            proceed: 'Continuar'
                        }
                    })
                    if (swalResponse) {
                        window.document.location = response.data.url
                    }
                }
            } else {
                // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
                if (response.msg) {
                    swal({
                        icon: response.class,
                        title: response.msg
                    })
                }
            }
            return response

        } catch (e) {
            console.error(e)
            mobiscroll.snackbar({
                display: 'top',
                theme: 'ios',
                message: 'Ocurrió un error obteniendo la respuesta',
                color: 'warning',
                duration: 7000
            })
            return false
        }
    }
}

// EXPORTS
export default {
    state,
    getters,
    mutations,
    actions
};